/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputAlgorithmScores
 */
export interface InputAlgorithmScores {
    /**
     * 
     * @type {string}
     * @memberof InputAlgorithmScores
     */
    algorithmPredictions: string;
    /**
     * 
     * @type {string}
     * @memberof InputAlgorithmScores
     */
    ansaParamQueueScores: string;
    /**
     * 
     * @type {string}
     * @memberof InputAlgorithmScores
     */
    packVodScores: string;
    /**
     * 
     * @type {string}
     * @memberof InputAlgorithmScores
     */
    modelRecommendations: string;
}

/**
 * Check if a given object implements the InputAlgorithmScores interface.
 */
export function instanceOfInputAlgorithmScores(value: object): value is InputAlgorithmScores {
    if (!('algorithmPredictions' in value) || value['algorithmPredictions'] === undefined) return false;
    if (!('ansaParamQueueScores' in value) || value['ansaParamQueueScores'] === undefined) return false;
    if (!('packVodScores' in value) || value['packVodScores'] === undefined) return false;
    if (!('modelRecommendations' in value) || value['modelRecommendations'] === undefined) return false;
    return true;
}

export function InputAlgorithmScoresFromJSON(json: any): InputAlgorithmScores {
    return InputAlgorithmScoresFromJSONTyped(json, false);
}

export function InputAlgorithmScoresFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAlgorithmScores {
    if (json == null) {
        return json;
    }
    return {
        
        'algorithmPredictions': json['algorithm_predictions'],
        'ansaParamQueueScores': json['ansa_param_queue_scores'],
        'packVodScores': json['pack_vod_scores'],
        'modelRecommendations': json['model_recommendations'],
    };
}

export function InputAlgorithmScoresToJSON(json: any): InputAlgorithmScores {
    return InputAlgorithmScoresToJSONTyped(json, false);
}

export function InputAlgorithmScoresToJSONTyped(value?: InputAlgorithmScores | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'algorithm_predictions': value['algorithmPredictions'],
        'ansa_param_queue_scores': value['ansaParamQueueScores'],
        'pack_vod_scores': value['packVodScores'],
        'model_recommendations': value['modelRecommendations'],
    };
}

